import { Component, Input, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { EnodeService } from 'src/app/services/enode/enode.service';
import { EnodeVehicle, UserLocation } from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-unlink-vendor-modal',
  templateUrl: './unlink-vendor-modal.component.html',
  styleUrls: ['./unlink-vendor-modal.component.scss']
})
export class UnlinkVendorModalComponent {
  @ViewChild(IonContent) content: IonContent;
  @Input() vehicles: EnodeVehicle[];

  selectedVendor: string;
  multipleVendors: boolean = false;
  allVendors: string[] = [];
  allVendorsCount: object = {};

  constructor(
    private modalCtrl: ModalController,
    private _enodeService: EnodeService
  ) {}

  ngOnInit() {
    if (this.vehicles.length === 1) {
      this.selectedVendor = this.vehicles[0].vendor;
      this.allVendors = [this.selectedVendor];
    }
    if (this.vehicles.length > 1) {
      const vendors = this.vehicles.map((v) => v.vendor);
      const vendorSet = new Set(vendors);
      if (vendorSet.size === 1) {
        this.selectedVendor = this.vehicles[0].vendor;
        this.allVendors = Array.from(vendorSet);
      } else {
        this.multipleVendors = true;
        this.allVendors = Array.from(vendorSet);
      }
      this.allVendorsCount = this.vehicles.reduce((acc, v) => {
        if (acc[v.vendor]) {
          acc[v.vendor] += 1;
        } else {
          acc[v.vendor] = 1;
        }
        return acc;
      }, {});
    }
  }

  deleteVehicle() {
    this._enodeService.deleteVehicle(this.selectedVendor).subscribe({
      next: () => {
        this.modalCtrl.dismiss();
      }
    });
  }

  cancel() {
    this.modalCtrl.dismiss({
      vehicles: this.vehicles
    });
  }
}
